var map = {
	"./frontend/BetslipHistory.vue": 5629,
	"./frontend/BodyFB.vue": 34,
	"./frontend/ContactUs.vue": 3338,
	"./frontend/DataTable.vue": 818,
	"./frontend/History.vue": 9867,
	"./frontend/Home.vue": 7621,
	"./frontend/Index.vue": 9113,
	"./frontend/Live.vue": 4249,
	"./frontend/MainMenu.vue": 7345,
	"./frontend/MaungFB.vue": 139,
	"./frontend/Setting.vue": 4727,
	"./frontend/VideoLink.vue": 6003,
	"./frontend/auth/Login.vue": 2200,
	"./frontend/auth/Rule.vue": 6704,
	"./frontend/components/AccountSelect.vue": 6353,
	"./frontend/components/DataTable.vue": 3639,
	"./frontend/components/FBPreviewVoucher.vue": 9503,
	"./frontend/components/FBVoucher.vue": 1896,
	"./frontend/components/FootballTeamCard.vue": 402,
	"./frontend/components/PreviewVoucher.vue": 4032,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 7128,
	"./frontend/normal-user/Index.vue": 5531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;